export enum SyncStatus {
    PENDING = 'pending',
    SUCCESS = 'success',
    FAILED = 'failed',
}
